(function() { window.GUID_f733fb23_6781_4ffe_b8b2_c2a5130a8807 = { getGuid: function() { return "f733fb23-6781-4ffe-b8b2-c2a5130a8807"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Tour extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.defaultFoxusBoxBoxShadow = "#faa41d 0px 0px 5px 2px, rgb(0 0 0 / 60%) 0px 0px 0px 1000vh";
                this.foxusBoxBoxShadowNoOverlay = "#faa41d 0px 0px 5px 2px";
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            get $ControlClone() {
                return this.$controlClone;
            }
            get $Overlay() {
                return this.$ControlClone.find(".cstour__overlay");
            }
            get $FocusBox() {
                return this.$ControlClone.find(".cstour__focus-box");
            }
            get $Tooltip() {
                return this.$ControlClone.find(".cstour__tooltip");
            }
            get $ContinueButton() {
                return this.$ControlClone.find(`#button-${this.controlId}-continue`);
            }
            get $SkipButton() {
                return this.$ControlClone.find(`#button-${this.controlId}-skip`);
            }
            get $FinishButton() {
                return this.$ControlClone.find(`#button-${this.controlId}-finish`);
            }
            get $CloseButton() {
                return this.$ControlClone.find(`#${this.controlId}-close`);
            }
            get CurrentStep() {
                return this.Steps[this.LastStepIndex];
            }
            get $CurrentTarget() {
                return $(`#${this.Steps[this.LastStepIndex].TargetId}`);
            }
            get $PreviousTarget() {
                if (this.LastStepIndex == 0)
                    return $();
                else
                    return $(`#${this.Steps[this.LastStepIndex - 1].TargetId}`);
            }
            $target(step) {
                return $(`#${step.TargetId}`);
            }
            get Steps() {
                return this.steps;
            }
            get LastStepIndex() {
                return this.lastStepIndex;
            }
            get AutoStart() {
                return this.autoStart;
            }
            get ContinueOnOverlayClick() {
                return this.continueOnOverlayClick;
            }
            get PostOnFinishedUrl() {
                return this.postOnFinishedUrl;
            }
            set PostOnFinishedUrl(value) {
                this.postOnFinishedUrl = value;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $("#" + params[0]);
                if (this.$Control.length > 0) {
                    const steps = this.$Control.data("steps");
                    if (steps != null && Array.isArray(steps))
                        this.steps = steps;
                    const $controlClone = this.$control.clone();
                    $controlClone.attr("id", $controlClone.attr("id") + "--clone");
                    this.$controlClone = $controlClone;
                    // Pour éviter un glitch avec les éléments clônés, on retire le html du control original
                    this.$Control.html("");
                    // On laisse le control original dans section-middle pour que le trigger de dispose ne soit pas affecté
                    CS.DOM.$body.append(this.$ControlClone);
                }
                const autoStart = params[1];
                this.autoStart = autoStart == "True";
                const continueOnOverlayClick = params[2];
                this.continueOnOverlayClick = continueOnOverlayClick == "True";
                const autoContinueDelay = parseInt(params[3]);
                if (autoContinueDelay != null && !isNaN(autoContinueDelay)) {
                    this.autoContinueDelay = autoContinueDelay;
                }
                else {
                    this.autoContinueDelay = 30 * 1000;
                }
                this.postOnFinishedUrl = params[4];
            }
            OnControlRendered() {
                this.Trigger(Tour.EventNames.Ready);
            }
            OnBindEvents() {
                this.$ContinueButton.offon("click.cstour-continue", (e) => {
                    this.Continue();
                });
                this.$SkipButton.offon("click.cstour-skip", (e) => {
                    this.Close();
                });
                this.$FinishButton.offon("click.cstour-finish", (e) => {
                    this.Close();
                });
                this.$CloseButton.offon("click.cstour-close", (e) => {
                    this.Close();
                });
                this.$FocusBox.offon("click.cstour-focus-box", (e) => {
                    this.Trigger(Tour.EventNames.FocusBoxClicked);
                    if (this.CurrentStep.AllowTargetClick) {
                        this.$CurrentTarget.trigger("click");
                    }
                });
                this.$Overlay.offon("click.cstour-overlay", (e) => {
                    if (!this.preventOverlayClick) {
                        if (this.ContinueOnOverlayClick)
                            this.Continue();
                        else
                            this.Close();
                    }
                });
                if (this.AutoStart) {
                    $(document).ready(() => {
                        CS.Lag("app-tour-start-delay", 500, () => {
                            this.Start();
                        });
                    });
                }
            }
            OnDispose() {
                this.$ControlClone.remove();
                this.stopAutoContinueTimeout();
            }
            Start() {
                if (this.$Control.length > 0) {
                    this.lastStepIndex = 0;
                    const step = this.Steps[0];
                    if (this.targetExists(step)) {
                        this.Trigger(Tour.EventNames.Started);
                        requestAnimationFrame((time) => {
                            this.preventScrollAndClickOutsideControl();
                            this.update(step);
                            this.show();
                            this.startAutoContinueTimeout();
                        });
                    }
                }
                else {
                    console.error(`$Control.length == ${this.$Control.length}`);
                }
            }
            Continue() {
                this.stopAutoContinueTimeout();
                if (this.hasNextStep()) {
                    let nextStepIsValid = false;
                    while (this.hasNextStep() && !nextStepIsValid) {
                        const step = this.Steps[this.LastStepIndex + 1];
                        this.lastStepIndex++;
                        if (this.targetExists(step)) {
                            nextStepIsValid = true;
                            this.Trigger(Tour.EventNames.Continued);
                            requestAnimationFrame((time) => {
                                this.startAutoContinueTimeout();
                                this.update(step);
                            });
                        }
                    }
                }
                else {
                    this.Close();
                }
            }
            Close() {
                this.stopAutoContinueTimeout();
                this.hide(() => {
                    this.restoreScrollAndClickOutsideControl();
                    this.Trigger(Tour.EventNames.Closed);
                    console.log(this.PostOnFinishedUrl);
                    if (this.PostOnFinishedUrl != null &&
                        this.PostOnFinishedUrl.trim() != "") {
                        CS.Ajax.Post(this.PostOnFinishedUrl, {}, (response) => {
                            //const { success } = response;
                            //this.Log({ url: this.PostOnFinishedUrl, success });
                        });
                    }
                });
                CS.DOM.$sectionBottom.css({ "z-index": "" });
            }
            update(step) {
                if (this.targetExists(step)) {
                    const $target = this.$target(step);
                    const getParams = () => {
                        return {
                            $target: this.$target(step),
                            step,
                            documentWidth: CS.DOM.$doc.outerWidth(),
                            documentHeight: CS.DOM.$doc.outerHeight(),
                            targetWidth: $target.outerWidth(),
                            targetHeight: $target.outerHeight(),
                            targetOffsetTop: $target.offset().top,
                            targetOffsetLeft: $target.offset().left,
                        };
                    };
                    let params = getParams();
                    const allNumericParams = Object.keys(params)
                        .filter((key) => key != "step" && key != "$target")
                        .map((key) => params[key]);
                    const allNumbers = CS.Helper.areNumeric(allNumericParams);
                    if (allNumbers) {
                        const observer = new CS.Helper.CSIntersectionObserver(this.$target(step));
                        if (this.$target(step).closest(CS.DOM.$subTop).length <= 0 &&
                            this.$target(step).closest(CS.DOM.$topBar).length <= 0 &&
                            !observer.elementIsFullyVisible() &&
                            !step.TargetIsFixed) {
                            observer.scrollUntilVisible(100, () => {
                                // Params are recomputed because the target may have moved/changed after scrolling.
                                this.updateCssAndContent(getParams());
                            });
                        }
                        else
                            this.updateCssAndContent(params);
                    }
                    else {
                        this.Close();
                    }
                }
            }
            updateCssAndContent(params) {
                const { $target, documentWidth, step, targetHeight, targetOffsetLeft, targetOffsetTop, targetWidth, } = params;
                const targetOffsetRight = documentWidth - targetOffsetLeft - targetWidth;
                const targetIsOnLeft = targetOffsetLeft <= targetOffsetRight;
                let borderRadius = $target.css("border-radius");
                if (borderRadius == null || borderRadius == "" || borderRadius == "0px")
                    borderRadius = "0.25em";
                // TODO : Si l'item est plus long que le viewport, il faudrait afficher le tooltip par-dessus
                this.$FocusBox.css({
                    width: targetWidth,
                    height: targetHeight,
                    position: "absolute",
                    top: targetOffsetTop,
                    left: targetOffsetLeft,
                    cursor: step.AllowTargetClick ? "pointer" : "default",
                    "border-radius": borderRadius,
                });
                this.preventOverlayClick = true;
                // TODO : Déterminer si le tooltip est affiché au-dessus ou en-dessous du target
                const clientHeight = document.documentElement.clientHeight;
                const position = $target[0].getBoundingClientRect();
                const targetTop = position.top;
                const targetIsOnBottom = targetTop > clientHeight / 2;
                this.$Tooltip.animate({
                    opacity: 0,
                }, 300, () => {
                    this.updateContent(step, () => {
                        let left = targetIsOnLeft ? targetOffsetLeft : "auto";
                        let right = targetIsOnLeft ? "auto" : targetOffsetRight;
                        const bodyWidth = CS.DOM.$body.outerWidth();
                        const lateral = isNaN(Number(left))
                            ? right
                            : left;
                        const overflowLateral = lateral + this.$Tooltip.outerWidth() > bodyWidth;
                        if (overflowLateral) {
                            console.log("Readapt");
                            left = "50%";
                            right = "unset";
                        }
                        this.$Tooltip.css({
                            top: targetIsOnBottom
                                ? targetOffsetTop - this.$Tooltip.outerHeight() - 25
                                : targetOffsetTop + targetHeight + 25,
                            bottom: "unset",
                            left: left,
                            right: right,
                            transform: overflowLateral ? "translateX(-50%)" : "unset",
                            width: overflowLateral ? "100%" : "unset",
                        });
                        const observer = new CS.Helper.CSIntersectionObserver(this.$Tooltip, 0, 0);
                        if (observer.isPartiallyHiddenBottom) {
                            this.$Tooltip.css({
                                top: "unset",
                                bottom: "1em",
                            });
                        }
                        if (step.TargetIsFixed) {
                            this.$Tooltip.css({
                                top: "unset",
                                bottom: "3em",
                            });
                        }
                        this.$Tooltip.animate({
                            opacity: 1,
                        }, 300, () => {
                            this.preventOverlayClick = false;
                        });
                    });
                });
            }
            updateContent(step, callback) {
                const { Header, Body, OverrideContentUrl, OverrideContentIsDrawer } = step;
                const $title = this.$Tooltip.find(".header .title");
                const $body = this.$Tooltip.find(".body");
                if ($title.length > 0)
                    $title.text(Header);
                if (Body)
                    $body.html(`<p>${Body}</p>`);
                if (!this.hasNextStep()) {
                    this.$SkipButton.addClass("opacity--0");
                    this.$ContinueButton.addClass("hidden");
                    this.$FinishButton.removeClass("hidden");
                }
                if (!OverrideContentIsDrawer) {
                    this.$Overlay.show();
                    this.$Tooltip.show();
                    this.$FocusBox.css({ "box-shadow": this.defaultFoxusBoxBoxShadow });
                    CS.DOM.$sectionBottom.css({ "z-index": "" });
                }
                if (OverrideContentUrl) {
                    if (OverrideContentIsDrawer) {
                        this.$Overlay.hide();
                        this.$Tooltip.hide();
                        this.$FocusBox.css({ "box-shadow": this.foxusBoxBoxShadowNoOverlay });
                        CS.DOM.$sectionBottom.css({ "z-index": 2500 });
                        Controls.Popup.ShowAjaxModal(OverrideContentUrl, {}, ({ popup, isPopup }) => {
                            if (isPopup) {
                                const $title = popup.$Control.find(".popup-header__title");
                                popup.$Control
                                    .find(".popup-inner")
                                    .css({ bottom: `${CS.DOM.$sectionBottom.outerHeight()}px` });
                                if ($title.length) {
                                    $title.text(Header);
                                }
                            }
                            this.$Overlay.hide();
                            CS.Lag("tooltilDelay", 100, () => {
                                callback.call(this);
                            });
                        }, ({ popup }) => {
                            this.Continue();
                        }, true, true);
                    }
                    else {
                        CS.Ajax.Get(OverrideContentUrl, null, (response) => {
                            if (response != null)
                                $body.html(response);
                            CS.Lag("tooltilDelay", 100, () => {
                                callback.call(this);
                            });
                        });
                    }
                }
                else {
                    CS.Lag("tooltilDelay", 100, () => {
                        callback.call(this);
                    });
                }
            }
            show() {
                this.$ControlClone.removeClass("hidden");
                this.$Tooltip.animate({
                    opacity: 1,
                }, 300, () => { });
                this.$FocusBox.animate({
                    opacity: 1,
                }, 300, () => { });
            }
            hide(callback) {
                this.$Tooltip.animate({
                    opacity: 0,
                }, 300, () => { });
                this.$FocusBox.animate({
                    opacity: 0,
                }, 300, () => {
                    this.$ControlClone.addClass("hidden");
                    if (this.Steps.length > 0) {
                        this.$SkipButton.toggleClass("hidden");
                        this.$FinishButton.toggleClass("hidden");
                        this.$ContinueButton.toggleClass("hidden");
                    }
                    if (callback)
                        callback.call(this);
                });
            }
            preventScrollAndClickOutsideControl() {
                CS.DOM.$body.addClass("overflow--hidden");
                CS.DOM.$sectionMaster.addClass("pointer-events--none");
            }
            restoreScrollAndClickOutsideControl() {
                CS.DOM.$body.removeClass("overflow--hidden");
                CS.DOM.$sectionMaster.removeClass("pointer-events--none");
            }
            targetExists(step) {
                let result = true;
                const $target = $(`#${step.TargetId}`);
                if ($target.length > 0) {
                    result = true;
                }
                else {
                    result = false;
                    console.error(`Element with id "${step.TargetId}" cannot be found`, step);
                }
                return result;
            }
            hasNextStep() {
                let result = true;
                const nextStepIndex = this.LastStepIndex + 1;
                if (nextStepIndex >= this.Steps.length)
                    result = false;
                return result;
            }
            startAutoContinueTimeout() {
                if (this.autoContinueDelay > 0) {
                    this.autoContinueTimeout = setTimeout(() => {
                        this.Continue();
                    }, this.autoContinueDelay);
                }
            }
            stopAutoContinueTimeout() {
                clearTimeout(this.autoContinueTimeout);
            }
        }
        Controls.Tour = Tour;
        (function (Tour) {
            class Events {
                static Ready(param) {
                    Controls.RegisterEvent(Tour, EventNames.Ready, param);
                }
                static Started(param) {
                    Controls.RegisterEvent(Tour, EventNames.Started, param);
                }
                static FocusBoxClicked(param) {
                    Controls.RegisterEvent(Tour, EventNames.FocusBoxClicked, param);
                }
                static Continued(param) {
                    Controls.RegisterEvent(Tour, EventNames.Continued, param);
                }
                static Closed(param) {
                    Controls.RegisterEvent(Tour, EventNames.Closed, param);
                }
            }
            Tour.Events = Events;
            class EventNames {
            }
            EventNames.Ready = "cstour-ready";
            EventNames.Started = "cstour-started";
            EventNames.FocusBoxClicked = "cstour-focus-box-clicked";
            EventNames.Continued = "cstour-continued";
            EventNames.Closed = "cstour-closed";
            Tour.EventNames = EventNames;
        })(Tour = Controls.Tour || (Controls.Tour = {}));
        class TourV2 {
            constructor(steps) {
                this.steps = steps;
                this.currentStepIndex = 0;
                this.currentPopover = null;
                this.state = "idle";
            }
            start() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log(this.constructor.name, "Starting tour...");
                        if (this.steps.length > 0) {
                            yield this.showStep(this.currentStepIndex);
                            CS.Helper.log(this.constructor.name, "Tour started");
                        }
                        else {
                            CS.Helper.log(this.constructor.name, "No steps to show");
                        }
                    }
                    catch (error) {
                        console.error("Error while starting tour", error);
                    }
                });
            }
            nextStep() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log(this.constructor.name, "Showing next step...");
                        if (this.state == "idle") {
                            this.state = "busy";
                        }
                        else {
                            CS.Helper.log(this.constructor.name, `Aborting because state is ${this.state}`);
                            this.state = "idle";
                            return;
                        }
                        yield this.endCurrentStep();
                        if (this.currentStepIndex < this.steps.length - 1) {
                            this.currentStepIndex++;
                            yield this.showStep(this.currentStepIndex);
                            this.state = "idle";
                            CS.Helper.log(this.constructor.name, "Next step shown");
                        }
                        else {
                            CS.Helper.log(this.constructor.name, "No next step to show");
                        }
                    }
                    catch (error) {
                        console.error("Error while showing next step", error);
                    }
                });
            }
            previousStep() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log(this.constructor.name, "Showing previous step...");
                        if (this.state == "idle") {
                            this.state = "busy";
                        }
                        else {
                            CS.Helper.log(this.constructor.name, `Aborting because state is ${this.state}`);
                            this.state = "idle";
                            return;
                        }
                        yield this.endCurrentStep();
                        if (this.currentStepIndex > 0) {
                            this.currentStepIndex--;
                            yield this.showStep(this.currentStepIndex);
                            CS.Helper.log(this.constructor.name, "Previous step shown");
                            this.state = "idle";
                        }
                        else {
                            CS.Helper.log(this.constructor.name, "No previous step to show");
                        }
                    }
                    catch (error) {
                        console.error("Error while showing previous step", error);
                    }
                });
            }
            end() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log(this.constructor.name, "Ending tour...");
                        yield this.endCurrentStep();
                        CS.Helper.log(this.constructor.name, "Tour ended");
                    }
                    catch (error) {
                        console.error("Error while ending tour", error);
                    }
                });
            }
            showStep(index) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log(this.constructor.name, `Showing step ${index}...`);
                        const step = this.steps[index];
                        const targetElement = document.querySelector(step.selector);
                        if (!targetElement) {
                            throw new Error(`Element with selector ${step.selector} not found`);
                        }
                        const url = CS.Url.CSUrl("GetTourStepContent");
                        let data = {
                            partialViewPath: step.key,
                        };
                        if (step.extraData != null) {
                            data = Object.assign(Object.assign({}, data), step.extraData);
                        }
                        this.currentPopover = new Controls.Popover(targetElement, url, data, step.withOverlay, step.allowClickOnTarget);
                        this.currentPopover.onHide = this.nextStep.bind(this);
                        yield this.currentPopover.show();
                        CS.Helper.log(this.constructor.name, `Step ${index} shown`);
                    }
                    catch (error) {
                        console.error("Error while showing tour step", error);
                    }
                });
            }
            endCurrentStep() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        CS.Helper.log(this.constructor.name, "Ending current step...");
                        this.hideCurrentPopover();
                        yield this.markCurrentStepAsSeen();
                        CS.Helper.log(this.constructor.name, "Current step ended");
                    }
                    catch (error) {
                        console.error("Error while ending current step", error);
                    }
                });
            }
            hideCurrentPopover() {
                try {
                    CS.Helper.log(this.constructor.name, "Hiding current popover...");
                    if (this.currentPopover) {
                        this.currentPopover.hide();
                        this.currentPopover = null;
                    }
                    CS.Helper.log(this.constructor.name, "Current popover hidden");
                }
                catch (error) {
                    console.error("Error while hiding current popover", error);
                }
            }
            markCurrentStepAsSeen() {
                return new Promise((resolve, reject) => {
                    try {
                        CS.Helper.log(this.constructor.name, "Marking current step as seen...");
                        const currentStep = this.steps[this.currentStepIndex];
                        const url = CS.Url.CSUrl("InsertAppUserData");
                        const data = {
                            category: currentStep.category,
                            key: currentStep.key,
                            value: new Date().toISOString(),
                        };
                        CS.Ajax.Post(url, data, (response) => {
                            CS.Helper.log(this.constructor.name, "Current step marked as seen");
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while marking current step as seen", error);
                        return reject(error);
                    }
                });
            }
        }
        Controls.TourV2 = TourV2;
        class TourStepV2 {
            constructor(selector, category, key, withOverlay = true, allowClickOnTarget = false, freezeUI = false, extraData = null) {
                this.selector = selector;
                this.category = category;
                this.key = key;
                this.withOverlay = withOverlay;
                this.allowClickOnTarget = allowClickOnTarget;
                this.freezeUI = freezeUI;
                this.extraData = extraData;
            }
        }
        Controls.TourStepV2 = TourStepV2;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=tour.js.map
